<template>
    <div style="padding: 20px;">
        <el-card class="box-card">
            <el-form :inline="true" class="demo-form-inline" size="small" :model="searchForm" ref="searchForm">
                <el-form-item label="股票名称" prop="name">
                    <el-input placeholder="股票名称" v-model="searchForm.name"></el-input>
                </el-form-item>

                <el-form-item label="股票编号" prop="code">
                    <el-input placeholder="股票编号" v-model="searchForm.code"></el-input>
                    <!-- <el-select placeholder="股票编号" v-model="searchForm.code">
                        <el-option v-for="item in categoryOptions" :key="item.value" :label="item.label"
                                   :value="item.value"></el-option>
                        <el-option label="区域二" value="beijing"></el-option>
                    </el-select> -->
                </el-form-item>

                <el-form-item label="股票价格" prop="price">
                <el-select v-model="searchForm.price" placeholder="选择排序方式" class="short-select">
                <el-option label="正序" value="asc"></el-option>
                <el-option label="倒序" value="desc"></el-option>
                </el-select>
                </el-form-item>

                <el-form-item label="量比" prop="volume_ratio">
                <el-select v-model="searchForm.volume_ratio" placeholder="选择排序方式" class="short-select">
                <el-option label="正序" value="asc"></el-option>
                <el-option label="倒序" value="desc"></el-option>
                </el-select>
                </el-form-item>

                <el-form-item label="换手率" prop="turnover_rate">
                <el-select v-model="searchForm.turnover_rate" placeholder="选择排序方式" class="short-select">
                <el-option label="正序" value="asc"></el-option>
                <el-option label="倒序" value="desc"></el-option>
                </el-select>
                </el-form-item>

                <el-form-item label="市盈率-动态" prop="dynamic_pe_ratio">
                <el-select v-model="searchForm.dynamic_pe_ratio" placeholder="选择排序方式" class="short-select">
                <el-option label="正序" value="asc"></el-option>
                <el-option label="倒序" value="desc"></el-option>
                </el-select>
                </el-form-item>

                <el-form-item label="市净率" prop="pb_ratio">
                <el-select v-model="searchForm.pb_ratio" placeholder="选择排序方式" class="short-select">
                <el-option label="正序" value="asc"></el-option>
                <el-option label="倒序" value="desc"></el-option>
                </el-select>
                </el-form-item>

                <el-form-item label="涨速" prop="rise_speed">
                <el-select v-model="searchForm.rise_speed" placeholder="选择排序方式" class="short-select">
                <el-option label="正序" value="asc"></el-option>
                <el-option label="倒序" value="desc"></el-option>
                </el-select>
                </el-form-item>

                <el-form-item label="5分钟涨跌" prop="minute_price_change">
                <el-select v-model="searchForm.minute_price_change" placeholder="选择排序方式" class="short-select">
                <el-option label="正序" value="asc"></el-option>
                <el-option label="倒序" value="desc"></el-option>
                </el-select>
                </el-form-item>

                <el-form-item label="60日涨跌幅" prop="day_price_change_percentage">
                <el-select v-model="searchForm.pday_price_change_percentage" placeholder="选择排序方式" class="short-select">
                <el-option label="正序" value="asc"></el-option>
                <el-option label="倒序" value="desc"></el-option>
                </el-select>
                </el-form-item>

                <el-form-item label="年初至今涨跌幅" prop="year_to_date_price_change_percentage">
                <el-select v-model="searchForm.year_to_date_price_change_percentage" placeholder="选择排序方式" class="short-select">
                <el-option label="正序" value="asc"></el-option>
                <el-option label="倒序" value="desc"></el-option>
                </el-select>
                </el-form-item>

                <el-form-item label="成交量" prop="deal">
                <el-select v-model="searchForm.deal" placeholder="选择排序方式" class="short-select">
                <el-option label="正序" value="asc"></el-option>
                <el-option label="倒序" value="desc"></el-option>
                </el-select>
                </el-form-item>
            </el-form>
            
            <el-row type="flex" justify="center">
                <el-button size="small" type="primary" @click="clickSearch">筛选</el-button>
                <el-button size="small" @click="resetSearchForm">重置</el-button>
            </el-row>
        </el-card>

        <el-card class="box-card" style="margin-top: 25px;">
            <div slot="header" class="clearfix">
                <span><i class="el-icon-s-grid"></i> 消息列表</span>
                <!--<el-button style="float: right;" type="primary" size="small" @click="clickAddDialog">
                    <i class="el-icon-circle-plus-outline"></i> 操作按钮
                </el-button>-->
            </div>
            <div>
                <el-table :data="tableData" border style="width: 100%" v-model=" tableData">
                    <el-table-column prop="name" label="股票名称"></el-table-column>
                        <el-table-column prop="code" label="股票代码"></el-table-column>
                        <el-table-column prop="price" label="最新价"></el-table-column>
                        <el-table-column prop="deal" label="成交量"></el-table-column>
                        <el-table-column prop="price_change_percentage" label="涨跌幅"></el-table-column>
                        <el-table-column prop="price_change" label="涨跌额"></el-table-column>
                        <el-table-column prop="amplitude" label="振幅"></el-table-column>
                        <el-table-column prop="最高" label="最高价"></el-table-column>
                        <el-table-column prop="最低" label="最低价"></el-table-column>
                        <el-table-column prop="今开" label="开盘价"></el-table-column>
                        <el-table-column prop="昨收" label="收盘价"></el-table-column>
                        <el-table-column prop="volume_ratio" label="量比"></el-table-column>
                        <el-table-column prop="turnover_rate" label="换手率"></el-table-column>
                        <el-table-column prop="dynamic_pe_ratio" label="市盈率-动态"></el-table-column>
                        <el-table-column prop="pb_ratio" label="市净率"></el-table-column>
                        <el-table-column prop="total_market_value" label="总市值（元）"></el-table-column>
                        <el-table-column prop="circulating_market_value" label="流通市值（元）"></el-table-column>
                        <el-table-column prop="rise_speed" label="涨速"></el-table-column>
                        <el-table-column prop="5_minute_price_change" label="5分钟涨跌"></el-table-column>
                        <el-table-column prop="60_day_price_change_percentage" label="60日涨跌幅"></el-table-column>
                        <el-table-column prop="year_to_date_price_change_percentage" label="年初至今涨跌幅"></el-table-column>
                    <el-table-column label="查看详情">
                        <template slot-scope="scope">
                            <el-button @click="handleClick(scope.row)" type="text" size="large">  --查看--</el-button>
                            <!-- <el-popconfirm title="这是一段内容确定删除吗？" @confirm="confirmDelete(scope.row)">
                                <el-button slot="reference" type="text" size="small">删除</el-button> -->
                            <!-- </el-popconfirm> -->
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <el-row type="flex" justify="end" style="margin-top: 30px;">
                <el-pagination
                        :total="page.totalCount"
                        :page-size="page.perPageSize"
                        background
                        layout="prev, pager, next, jumper"
                        @current-change="handleCurrentChange"
                >
                </el-pagination>
            </el-row>
        </el-card>



        <el-dialog title="股票详情" :visible.sync="dialogVisible" width="80%" height="80%">
            <div>
            <el-col :span="12">
                <el-card class="box-card" shadow="never">
                    <highcharts :options="opt1" style="height: 330px;min-width: 300px"></highcharts>
                </el-card>
            </el-col>
            <el-row style="margin-top: 30px;" :gutter="20">
            <el-col :span="12">
                <el-row type="flex" justify="space-between" :gutter="20" style="flex-wrap: wrap">
                    <el-col :span="12">
                        <el-card shadow="never" class="stat-panel">
                            <div class="row">
                                <el-row type="flex" justify="space-between">
                                    <div>
                                        <div style="font-size: 80px; font-weight: bold">0</div>
                                        <div>股票价格</div>
                                    </div>
                                    <div>
                                        <i class="el-icon-attract" style="font-size: 60px;color: #0c8eff"></i>
                                    </div>
                                </el-row>
                                <el-row type="flex" justify="space-between">
                                    <div>最高价格：{{showdata.trace_max}}</div>
                                    <div>时间：{{showdata.trace_today}}</div>
                                </el-row>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="12">
                        <el-card shadow="never" class="stat-panel">
                            <div class="row">
                                <el-row type="flex" justify="space-between">
                                    <div>
                                        <div style="font-size: 80px;font-weight: bold">0</div>
                                        <div>股票价格</div>
                                    </div>
                                    <div>
                                        <i class="el-icon-attract" style="font-size: 60px;color: #0c8eff"></i>
                                    </div>
                                </el-row>
                                <el-row type="flex" justify="space-between">
                                    <div>最低价格：{{showdata.trace_min}}</div>
                                    <div>时间：{{showdata.trace_today_min}}</div>
                                </el-row>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="12" style="margin-top: 8px">
                        <el-card shadow="never" class="stat-panel">
                            <div class="row">
                                <el-row type="flex" justify="space-between">
                                    <div>
                                        <div style="font-size: 80px;font-weight: bold">0</div>
                                        <div>股票增长率</div>
                                    </div>
                                    <div>
                                        <i class="el-icon-attract" style="font-size: 60px;color: #0c8eff"></i>
                                    </div>
                                </el-row>
                                <el-row type="flex" justify="space-between">
                                    <div>最高增长率：{{showdata.change_max}}</div>
                                    <div>时间：{{showdata.change_today}}</div>
                                </el-row>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="12" style="margin-top: 8px">
                        <el-card shadow="never" class="stat-panel">
                            <div class="row">
                                <el-row type="flex" justify="space-between">
                                    <div>
                                        <div style="font-size: 80px;font-weight: bold">0</div>
                                        <div>股票增长率</div>
                                    </div>
                                    <div>
                                        <i class="el-icon-attract" style="font-size: 60px;color: #0c8eff"></i>
                                    </div>
                                </el-row>
                                <el-row type="flex" justify="space-between">
                                    <div>最低增长率：{{showdata.change_min}}</div>
                                    <div>时间：{{showdata.change_today_min}}</div>
                                </el-row>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>

            </el-col>
        </el-row>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
              </span>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
//http://data.koudaimao.top
var host = 'http://43.153.108.9:8011/'
// import qs from'qs'
    export default {
        name: "Push",
        data() {
            return {
                showdata:{
                    trace_max:0,
                    trace_today:0,
                    trace_min:0,
                    trace_today_min:0,
                    change_max:0,
                    change_today:0,
                    change_min:0,
                    change_today_min:0,
                },
                opt1: {
                    title: {
                        text: '股票交易详情'
                    },
                    subtitle: {
                        text: ' '
                    },
                    yAxis: {
                        title: {
                            text: '数量'
                        }
                    },
                    legend: {
                        layout: 'vertical',
                        align: 'right',
                        verticalAlign: 'middle'
                    },
                    xAxis: {
                        categories: []
                    },
                    plotOptions: {
                        line: {
                            dataLabels: {
                                // 开启数据标签
                                enabled: false        
                            },
                            // 关闭鼠标跟踪，对应的提示框、点击事件会失效
                            enableMouseTracking: false
                        // series: {
                        //     label: {
                        //         connectorAllowed: false
                        //     },
                        //     pointStart: 20230122,
                        // }
                    }},
                    series: [{
                        name: '交易单价(元)',
                        data: []
                    }, {
                        name: '价格变化百分比(%)',
                        data: []
                    }, {
                        name: '交易量(万)',
                        data: []
                    }, {
                        name: '交易总额(万)',
                        data: []
                    }],
                    responsive: {
                        rules: [{
                            condition: {
                                maxWidth: 500
                            },
                            chartOptions: {
                                legend: {
                                    layout: 'horizontal',
                                    align: 'center',
                                    verticalAlign: 'bottom'
                                }
                            }
                        }]
                    }
                },
                // 传入的参数
                searchForm: {
                    name: "", 
                    code: "", 
                    price: "", 
                    volume_ratio: "", 
                    turnover_rate: "", 
                    dynamic_pe_ratio: "", 
                    pb_ratio: "",
                    rise_speed: "", 
                    minute_price_change: "", 
                    day_price_change_percentage: "", 
                    year_to_date_price_change_percentage: "", 
                    deal: "", 
                },
                
                tableData: [],
                page: {
                    totalCount: 5500,
                    perPageSize: 20
                },
                dialogFormVisible: false,
                addForm: {
                    x1: "",
                    x2: ""
                },
                dialogVisible:false
            }
        },
        methods: {
            extral_time(normal_time) {
                var year=normal_time.getFullYear()
                var month = normal_time.getMonth() + 1
                console.log('month', month)
                if (month.toString().length == 1) {
                    month =  '0'.toString().concat(month.toString())
                }
                var day = normal_time.getDate()
                console.log('day', day)
                if (day.length == 1) {
                    day = '0' + day
                }
                return year.toString() + month.toString() + day.toString()

            },
            clickSearch() {
                console.log(this.searchForm);
                console.log("筛选");
                const newData = {
                    ...this.searchForm, // 复制 searchForm 的内容
                    offset: 0, // 设置 offset 字段
                    limit:20
                    };
                axios.post(host + "api/realtime_a_bond", newData)
                .then(res=> {
                    console.log(res)
                    this.tableData = res.data.data
                    this.page.perPageSize = 20
                })
                .catch(error=>{
                    console.log(error);
                });
            },
            resetSearchForm() {
                this.searchForm = {
                    name: "", 
                    code: "", 
                    price: "", 
                    volume_ratio: "", 
                    turnover_rate: "", 
                    dynamic_pe_ratio: "", 
                    pb_ratio: "",
                    rise_speed: "", 
                    minute_price_change: "", 
                    day_price_change_percentage: "", 
                    year_to_date_price_change_percentage: "", 
                    deal: "", 
                };
            },
            handleClick(row) {
                var formData = new FormData();
                console.log(row['Code']);
                formData.append("Code", row['Code']);
                axios.post(host + "api/realtime_a_bond", formData)
                .then(res=> {
                    console.log(res)
                    this.opt1.series[0]["data"] = res.data.message["Trace"]
                    this.opt1.series[1]["data"] = res.data.message["Changepercent"]
                    this.opt1.series[2]["data"] = res.data.message["Volume"]
                    this.opt1.series[3]["data"] = res.data.message["Amount"]
                    this.opt1.xAxis.categories = res.data.message["Timenow"]
                    this.showdata.trace_max = Math.max.apply(null, this.opt1.series[0]["data"])
                    this.showdata.trace_today = res.data.message["Timenow"][res.data.message["Trace"].indexOf(Math.max.apply(null, this.opt1.series[0]["data"]))]
                    this.showdata.trace_min = Math.min.apply(null, this.opt1.series[0]["data"])
                    this.showdata.trace_today_min=res.data.message["Timenow"][res.data.message["Trace"].indexOf(Math.min.apply(null, this.opt1.series[0]["data"]))]
                    this.showdata.change_max=parseInt(Math.max.apply(null, this.opt1.series[1]["data"]))
                    this.showdata.change_today=res.data.message["Timenow"][res.data.message["Changepercent"].indexOf(Math.max.apply(null, this.opt1.series[1]["data"]))]
                    this.showdata.change_min=parseInt(Math.min.apply(null, this.opt1.series[1]["data"]))
                    this.showdata.change_today_min=res.data.message["Timenow"][res.data.message["Changepercent"].indexOf(Math.min.apply(null, this.opt1.series[1]["data"]))]
                })
                this.dialogVisible = true;
            },
            confirmDelete(row) {
                console.log("确定删除", row);
            },
            handleCurrentChange(page) {
                console.log(this.searchForm);
                console.log("翻页");
                const newData = {
                    ...this.searchForm, // 复制 searchForm 的内容
                    offset: 20 * page, // 设置 offset 字段
                    limit:20
                    };

                axios.post(host + "api/realtime_a_bond", newData)
                .then(res=> {
                    console.log(res)
                    this.tableData = res.data.data
                    this.page.perPageSize = 20
                })
                .catch(error=>{
                    console.log(error);
                });
            },
            clickAddDialog() {
                this.dialogFormVisible = true;
            },
            inData() {
                axios.post(host + "api/realtime_a_bond", {"limit":20})
                .then(res=> {
                    console.log(res.data.data)
                    console.log('ok')
                    this.tableData = res.data.data

                })
                .catch(error=>{
                    console.log(error);
                });
            },
        },
        mounted() {
    this.inData()
        }
    }
</script>

<style scoped>

</style>

